import AccountService from '@/services/AccountService'

const state = () => ({
  roles: []
})

const mutations = {
  setCustomerRoles(state, roles) {
    state.roles = roles
  }
}

const getters = {
  hasCustomerRole: (state) => (roleName) => {
    return state.roles.includes(roleName)
  }
}

const actions = {
  // Fetch the roles from the API and commit to the store
  async fetchCustomerRoles({ commit }) {
    try {
      const response = await AccountService.fetchCustomerRoles(); // Call the API
      const roles = response.data || []; // Get the roles from the API response
      commit('setCustomerRoles', roles); // Commit the roles to Vuex store
    } catch (error) {
      console.error('Failed to fetch customer roles:', error);
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions  // Ensure actions are included in the export
}
